import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/ma.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-e38e8d9c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "foot"
};
var _hoisted_2 = {
  class: "foot_top"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "ma"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "foot_text"
  }, "百城智联官方公众号"), /*#__PURE__*/_createElementVNode("div", {
    class: "foot_text"
  }, "欢迎咨询")], -1);
});

var _hoisted_4 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_5 = {
  class: "block"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title"
  }, "产品网站", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_content"
  }, "百城官网", -1);
});

var _hoisted_8 = {
  class: "block"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title"
  }, "商务合作", -1);
});

var _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"block\" data-v-e38e8d9c><div class=\"block_title\" data-v-e38e8d9c>联系我们</div><div class=\"block_content\" data-v-e38e8d9c>邮箱：business@bcepd.cn </div><div class=\"block_content\" data-v-e38e8d9c>电话：0571-63566393</div><div class=\"block_content\" data-v-e38e8d9c>浙江省杭州市富阳区银湖街道 <br data-v-e38e8d9c> 富闲路9号银湖创新中心1号楼13层</div></div>", 1);

var _hoisted_11 = {
  class: "foot_bottom"
};

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" 版权所有：杭州百城智联科技有限公司 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _createElementVNode("div", {
    class: "block_content",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleQimingxing && _ctx.handleQimingxing.apply(_ctx, arguments);
    })
  }, "启明星官网"), _createElementVNode("div", {
    class: "block_content",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.handleHuiben && _ctx.handleHuiben.apply(_ctx, arguments);
    })
  }, "绘本通官网")]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", {
    class: "block_content",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.handleParter && _ctx.handleParter.apply(_ctx, arguments);
    })
  }, "合作伙伴"), _createElementVNode("div", {
    class: "block_content",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.handleJoin && _ctx.handleJoin.apply(_ctx, arguments);
    })
  }, "工作机会")]), _hoisted_10])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.handleBeian && _ctx.handleBeian.apply(_ctx, arguments);
    }),
    class: "beian"
  }, " 浙ICP备2020037287号-1")])]);
}